import Menu from 'assets/images/home/Menu.svg'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toggleSideBar } from 'store/redux/sidebar'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <>
            <div className="bg-header-bg w-full px-4 h-14 flex items-center justify-between sticky top-0 z-20 shadow-header">
                <img
                    src={Menu}
                    alt="منو"
                    onClick={() => dispatch(toggleSideBar({ isOpen: true }))}
                    className="w-6 h-6 cursor-pointer active:scale-90"
                />
                <p className="text-green-1 text-xl font-bold tracking-tight">
                    {title}
                </p>
                <button
                    aria-label="ساخت صندوق"
                    className="w-9 h-9 flex items-center justify-center rounded-full text-green-1 text-3xl leading-none active:scale-90"
                    onClick={() => navigate('/add-box/moneyPool')}
                >
                    +
                </button>
            </div>
        </>
    )
}
